import { createContext } from 'react'

export const ChatRefsContext = createContext(null)
